import { moduleFactory } from "@/factories/module";
import {
  electronBindingNavigateToExternalUrl,
  electronBindingNavigateToInternalUrl,
  electronBindingToggleMenu,
  electronBindingUpdateNow,
  electronBindingGetDesktopUpdateStatus,
  electronBindingCheckForDesktopUpdate,
  electronBindingInstallDesktopUpdate,
  electronBindingPromptCriticalDesktopUpdate,
  electronBindingOnDesktopUpdateStatusChanged,
  electronBindingMinimizeWindow,
  electronBindingMaximizeWindow,
  electronBindingCloseWindow,
  electronBindingSetOAuthAccessToken,
  electronBindingClearOAuthAccessToken,
  electronBindingOnOAuthAccessTokenGetRequested,
  electronBindingRespondToOAuthAccessTokenGetRequest,
  electronBindingOnOAuthAccessTokenRefreshRequested,
  electronBindingRestartApp,
  electronBindingOpenSystemSoundSettings,
  electronBindingSetTheme,
  electronBindingOnBrowserMetadata,
  electronBindingGetMarketingAttribution,
  electronBindingOnMarketingAttribution,
  recallBindingPrepareDesktopRecording,
  recallBindingStartRecording,
  recallBindingReplaceRecording,
  recallBindingPauseRecording,
  recallBindingResumeRecording,
  recallBindingStopRecording,
  recallBindingGetRecordingSession,
  recallBindingGetRecordingRecoveryState,
  recallBindingPauseRecordingSession,
  recallBindingResumeRecordingSession,
  recallBindingStopRecordingSession,
  recallBindingOnEvent,
  recallBindingGetPermissionStatus,
  recallBindingRequestPermission,
  recallBindingOnPermissionStatus,
  recallBindingOpenPermissionPane,
  recallBindingOnMeetingEvent,
  recallBindingGetSdkState,
  recallBindingOnSdkState,
  recallBindingTestUnexpectedShutdown,
  electronBindingSetCalendarEvents,
  electronBindingOnTrackedEvent,
  electronBindingSetCalendarNotificationEnabled,
  electronBindingGetCalendarNotificationEnabled,
  electronBindingSetMeetingNotificationEnabled,
  electronBindingGetMeetingNotificationEnabled,
  electronBindingSetSpellcheckEnabled,
  electronBindingGetSpellcheckEnabled,
  electronBindingSetIsClientReady,
  electronBindingSetClientMetadata,
  electronBindingClearClientMetadata,
  electronBindingGetElectronAppInfo,
  electronBindingImportAppleNotes,
  electronBindingGetAppleNoteContent,
  electronBindingCloseAppleNotesReader,
  electronBindingSetTeamsMeetingDetectionEnabled,
  electronBindingGetTeamsMeetingDetectionEnabled,
  electronBindingGetAdvancedMeetingDetectionShown,
  electronBindingSetAdvancedMeetingDetectionShown,
  electronBindingOnMenuActionEvent,
  electronBindingOnDesktopShortcutEvent,
  electronBindingResetTccAndClearCache,
  electronBindingGetAudioArtifactRef,
  electronBindingGetAudioArtifactSnapshot,
  electronBindingGetAudioArtifactUploadFailureDebugInfo,
  electronBindingFinalizeAudioArtifact,
  electronBindingRemoveAudioArtifact,
  electronBindingStartAudioUpload,
  electronBindingOnAudioUploadProgress,
  electronBindingOnAudioUploadCompleted,
  electronBindingOnAudioUploadError,
  electronBindingOnDesktopAudioWaveformUpdate,
  electronBindingConfigureFloatingAgent,
  electronBindingSetFloatingAgentUnreadState,
  electronBindingSetFloatingAgentInteractionActive,
  electronBindingFloatingAgentPresentationReleased,
  electronBindingSetFloatingAgentHoldToTalkKey,
  electronBindingStartFloatingAgentOnboardingNudge,
  electronBindingCompleteFloatingAgentFirstMessageOnboarding,
  electronBindingFloatingAgentDragMove,
  electronBindingFloatingAgentDragEnd,
  electronBindingFloatingAgentWindowDragMove,
  electronBindingFloatingAgentWindowDragEnd,
  electronBindingFloatingAgentResize,
  electronBindingFloatingAgentSetPointerPassthrough,
  electronBindingFloatingAgentVoiceCaptureFailed,
  electronBindingFloatingAgentGetAnchor,
  electronBindingFloatingAgentSummonMainApp,
  electronBindingFloatingAgentOpenPanel,
  electronBindingFloatingAgentOpenNativeChatLimitUpsell,
  electronBindingFloatingAgentOpenProactiveUpsell,
  electronBindingFloatingAgentHide,
  electronBindingFloatingAgentTooltipShow,
  electronBindingFloatingAgentTooltipHide,
  electronBindingFloatingAgentOpenTasks,
  electronBindingFloatingAgentOpenMemAgentSettings,
  electronBindingFloatingAgentOpenMention,
  electronBindingFloatingAgentOnOpenTasks,
  electronBindingFloatingAgentOnOpenMemAgentSettings,
  electronBindingFloatingAgentOnOpenMention,
  electronBindingFloatingAgentSetForegroundContext,
  electronBindingFloatingAgentAttachComposerMentions,
  electronBindingFloatingAgentGetForegroundContext,
  electronBindingFloatingAgentTakeComposerMentions,
  electronBindingFloatingAgentTrackProactiveTrialBannerEvent,
  electronBindingFloatingAgentRendererReady,
  electronBindingFloatingAgentOnEvent,
  electronBindingAddWorkingContextSubscription,
  electronBindingGetWorkingContextSnapshot,
  electronBindingGetWorkingContextStatus,
  electronBindingOnWorkingContextMatch,
  electronBindingRemoveWorkingContextSubscription,
} from "@/modules/electron/bindings";

export const electronModule = moduleFactory.create({
  navigateToInternalUrl: electronBindingNavigateToInternalUrl,
  navigateToExternalUrl: electronBindingNavigateToExternalUrl,
  toggleMenu: electronBindingToggleMenu,
  minimizeWindow: electronBindingMinimizeWindow,
  maximizeWindow: electronBindingMaximizeWindow,
  closeWindow: electronBindingCloseWindow,
  oauthAccessToken: {
    set: electronBindingSetOAuthAccessToken,
    clear: electronBindingClearOAuthAccessToken,
    onGetRequested: electronBindingOnOAuthAccessTokenGetRequested,
    respondToGetRequest: electronBindingRespondToOAuthAccessTokenGetRequest,
    onRefreshRequested: electronBindingOnOAuthAccessTokenRefreshRequested,
  },
  updateNow: electronBindingUpdateNow,
  desktopUpdater: {
    getStatus: electronBindingGetDesktopUpdateStatus,
    check: electronBindingCheckForDesktopUpdate,
    install: electronBindingInstallDesktopUpdate,
    promptCriticalUpdate: electronBindingPromptCriticalDesktopUpdate,
    onStatusChanged: electronBindingOnDesktopUpdateStatusChanged,
  },
  restartApp: electronBindingRestartApp,
  openSystemSoundSettings: electronBindingOpenSystemSoundSettings,
  setTheme: electronBindingSetTheme,
  setCalendarNotificationEnabled: electronBindingSetCalendarNotificationEnabled,
  getCalendarNotificationEnabled: electronBindingGetCalendarNotificationEnabled,
  setMeetingNotificationEnabled: electronBindingSetMeetingNotificationEnabled,
  getMeetingNotificationEnabled: electronBindingGetMeetingNotificationEnabled,
  setSpellcheckEnabled: electronBindingSetSpellcheckEnabled,
  getSpellcheckEnabled: electronBindingGetSpellcheckEnabled,
  setTeamsMeetingDetectionEnabled: electronBindingSetTeamsMeetingDetectionEnabled,
  getTeamsMeetingDetectionEnabled: electronBindingGetTeamsMeetingDetectionEnabled,
  setAdvancedMeetingDetectionShown: electronBindingSetAdvancedMeetingDetectionShown,
  getAdvancedMeetingDetectionShown: electronBindingGetAdvancedMeetingDetectionShown,
  onBrowserMetadata: electronBindingOnBrowserMetadata,
  getMarketingAttribution: electronBindingGetMarketingAttribution,
  onMarketingAttribution: electronBindingOnMarketingAttribution,
  setCalendarEvents: electronBindingSetCalendarEvents,
  onMenuActionEvent: electronBindingOnMenuActionEvent,
  onDesktopShortcutEvent: electronBindingOnDesktopShortcutEvent,
  onTrackedEvent: electronBindingOnTrackedEvent,
  setIsClientReady: electronBindingSetIsClientReady,
  setClientMetadata: electronBindingSetClientMetadata,
  clearClientMetadata: electronBindingClearClientMetadata,
  getElectronAppInfo: electronBindingGetElectronAppInfo,
  importAppleNotes: electronBindingImportAppleNotes,
  getAppleNoteContent: electronBindingGetAppleNoteContent,
  closeAppleNotesReader: electronBindingCloseAppleNotesReader,
  resetTccAndClearCache: electronBindingResetTccAndClearCache,
  recall: {
    prepareDesktopRecording: recallBindingPrepareDesktopRecording,
    startRecording: recallBindingStartRecording,
    replaceRecording: recallBindingReplaceRecording,
    pause: recallBindingPauseRecording,
    resume: recallBindingResumeRecording,
    stop: recallBindingStopRecording,
    getRecordingSession: recallBindingGetRecordingSession,
    getRecordingRecoveryState: recallBindingGetRecordingRecoveryState,
    pauseRecordingSession: recallBindingPauseRecordingSession,
    resumeRecordingSession: recallBindingResumeRecordingSession,
    stopRecordingSession: recallBindingStopRecordingSession,
    onEvent: recallBindingOnEvent,
    onMeetingEvent: recallBindingOnMeetingEvent,
    getPermissionStatus: recallBindingGetPermissionStatus,
    requestPermission: recallBindingRequestPermission,
    onPermissionStatus: recallBindingOnPermissionStatus,
    openPermissionPane: recallBindingOpenPermissionPane,
    getSdkState: recallBindingGetSdkState,
    onSdkState: recallBindingOnSdkState,
    testUnexpectedShutdown: recallBindingTestUnexpectedShutdown,
  },
  audioArtifacts: {
    getAudioArtifactRef: electronBindingGetAudioArtifactRef,
    getAudioArtifactSnapshot: electronBindingGetAudioArtifactSnapshot,
    getAudioArtifactUploadFailureDebugInfo: electronBindingGetAudioArtifactUploadFailureDebugInfo,
    finalizeAudioArtifact: electronBindingFinalizeAudioArtifact,
    removeAudioArtifact: electronBindingRemoveAudioArtifact,
  },
  audioUpload: {
    startAudioUpload: electronBindingStartAudioUpload,
    onProgress: electronBindingOnAudioUploadProgress,
    onCompleted: electronBindingOnAudioUploadCompleted,
    onError: electronBindingOnAudioUploadError,
  },
  audioWaveform: {
    onUpdate: electronBindingOnDesktopAudioWaveformUpdate,
  },
  workingContext: {
    getStatus: electronBindingGetWorkingContextStatus,
    getSnapshot: electronBindingGetWorkingContextSnapshot,
    addSubscription: electronBindingAddWorkingContextSubscription,
    removeSubscription: electronBindingRemoveWorkingContextSubscription,
    onMatch: electronBindingOnWorkingContextMatch,
  },
  floatingAgent: {
    configure: electronBindingConfigureFloatingAgent,
    setUnreadState: electronBindingSetFloatingAgentUnreadState,
    setInteractionActive: electronBindingSetFloatingAgentInteractionActive,
    presentationReleased: electronBindingFloatingAgentPresentationReleased,
    setHoldToTalkKey: electronBindingSetFloatingAgentHoldToTalkKey,
    startOnboardingNudge: electronBindingStartFloatingAgentOnboardingNudge,
    completeFirstMessageOnboarding: electronBindingCompleteFloatingAgentFirstMessageOnboarding,
    dragMove: electronBindingFloatingAgentDragMove,
    dragEnd: electronBindingFloatingAgentDragEnd,
    windowDragMove: electronBindingFloatingAgentWindowDragMove,
    windowDragEnd: electronBindingFloatingAgentWindowDragEnd,
    resize: electronBindingFloatingAgentResize,
    setPointerPassthrough: electronBindingFloatingAgentSetPointerPassthrough,
    voiceCaptureFailed: electronBindingFloatingAgentVoiceCaptureFailed,
    getAnchor: electronBindingFloatingAgentGetAnchor,
    summonMainApp: electronBindingFloatingAgentSummonMainApp,
    openPanel: electronBindingFloatingAgentOpenPanel,
    openNativeChatLimitUpsell: electronBindingFloatingAgentOpenNativeChatLimitUpsell,
    openProactiveUpsell: electronBindingFloatingAgentOpenProactiveUpsell,
    hide: electronBindingFloatingAgentHide,
    tooltipShow: electronBindingFloatingAgentTooltipShow,
    tooltipHide: electronBindingFloatingAgentTooltipHide,
    openTasks: electronBindingFloatingAgentOpenTasks,
    onOpenTasks: electronBindingFloatingAgentOnOpenTasks,
    openMention: electronBindingFloatingAgentOpenMention,
    onOpenMention: electronBindingFloatingAgentOnOpenMention,
    openMemAgentSettings: electronBindingFloatingAgentOpenMemAgentSettings,
    onOpenMemAgentSettings: electronBindingFloatingAgentOnOpenMemAgentSettings,
    setForegroundContext: electronBindingFloatingAgentSetForegroundContext,
    getForegroundContext: electronBindingFloatingAgentGetForegroundContext,
    attachComposerMentions: electronBindingFloatingAgentAttachComposerMentions,
    takeComposerMentions: electronBindingFloatingAgentTakeComposerMentions,
    trackProactiveTrialBannerEvent: electronBindingFloatingAgentTrackProactiveTrialBannerEvent,
    rendererReady: electronBindingFloatingAgentRendererReady,
    onEvent: electronBindingFloatingAgentOnEvent,
  },
});
